<template>
  <div class="bg-red-500 p-3 fixed w-full bottom-0 text-center">
      <p>Data sourced from &#x1F449; <a class="underline" href="https://covid19api.com/">Covid-19 API</a></p>
      <small>Tim Atherton 2020 - &#x1F5A5; <a class="underline" href="https://www.tatherton.com/">Website</a> &#x1F525; <a class="underline" href="https://github.com/taweb">Repo</a></small>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>